import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import {useMap} from '@vis.gl/react-google-maps';
import Input from 'shared/components/Input';
import {Button} from 'shared/components/buttons';
import ActionLink from 'shared/components/links/ActionLink';
import {t} from 'shared/core';
import {useState} from 'react';
import GoogleMapsApi from '../GoogleMapsApi';

const AddressForm = observer(({onChange, onError, clearError}) => {
  const map = useMap();
  const [address, setAddress] = useState('');

  async function handleSearch() {
    clearError();

    const {results, error} = await GoogleMapsApi.geocode({address});

    if (error) {
      onError(error);
      return;
    }

    const topResult = results[0];
    const {formatted_address} = topResult;
    const {lat, lng} = topResult.geometry.location;

    map.panTo({lat, lng});
    map.setZoom(15);
    onChange({lat, lng, address: formatted_address});
  }

  function handleCurrentLocation() {
    clearError();

    navigator.geolocation.getCurrentPosition(async (position) => {
      const {latitude: lat, longitude: lng} = position.coords;
      const {results, error} = await GoogleMapsApi.geocode({lat, lng});

      if (error) {
        onError(error);
        return;
      }

      const {formatted_address} = results[0];

      map.panTo({lat, lng});
      map.setZoom(15);
      onChange({lat, lng, address: formatted_address});
    }, () => {
      onError(t('components.google_location_picker.Unable to get your location.'));
    });
  }

  return (
    <form className='mb1'>
      <div className='flex gap-1'>
        <div className='flex-grow'>
          <Input
            type='search'
            value={address}
            onChange={e => setAddress(e.target.value)}
            placeholder='components.google_location_picker.Enter an address'
          />
        </div>
        <Button onClick={handleSearch} type='submit' trait='default' disabled={!address.trim()}>
          <FormattedMessage id='components.google_location_picker.Search'/>
        </Button>
      </div>
      <span onClick={handleCurrentLocation} className='mt1 align-items-center clickable' style={{display: 'inline-flex'}}>
        <i className='material-icons dodger pr1' style={{fontSize: '18px'}}>{'my_location'}</i>
        <ActionLink>
          <FormattedMessage id='components.google_location_picker.Use my current location'/>
        </ActionLink>
      </span>
    </form>
  );
});

export default AddressForm;
